/**
 * Normalizes a proposal, but also clears "adjustmentValues" and adds an adjustments property
 * to be populated with the adjustmentValue objects, augmented with a copy of the proposal values
 * so that we can revert changes.
 */
function normalizeProposal(p, workspace) {
  let ret = {
    ...p,
    adjustmentValues: undefined,
    adjustments: {},
    allIds: [],
  };
  for (let av of p.adjustmentValues) {
    let pav = { ...av };
    const adj = workspace.adjustments.find(
      (a) => a.adjustmentId === av.adjustmentId,
    );
    ret.allIds.push(av.adjustmentId);

    // capture control type
    pav.controlType = adj.controlType;

    // track proposal values so we can reset
    pav.proposalValues = av.values;
    switch (adj.controlType) {
      case 'table': {
        pav.proposalTableId = av.tableId;
        pav.proposalVariableId = av.variableId;
        break;
      }
      case 'aggCostTable': {
        pav.proposalAggCostTableId = av.aggCostTableId;
        break;
      }
      case 'addlPayGradeIncr': {
        pav.proposalPayGradeMinMax = av.payGradeMinMax;
        break;
      }
      case 'pooledEmployee': {
        pav.proposalPooledInput = av.pooledInput;
        break;
      }
      default: {
      }
    }

    ret.adjustments[pav.adjustmentId] = pav;
  }
  return ret;
}

/**
 * Maps the proposals to a structure with 'allIds' and 'byId' so we can easily find specific
 * proposals.  The proposals themselves have a more complex mapping.
 */
export function normalizeProposals(workspace) {
  let ret = {
    allIds: [],
    byId: {},
  };
  for (let p of workspace.proposals) {
    ret.allIds.push(p.proposalId);
    ret.byId[p.proposalId] = normalizeProposal(p, workspace);
  }
  return ret;
}

/**
 * Maps the groups to a structure with 'allIds' and 'byId' so we can easily find specific
 * groups.
 */
export function normalizeGroups(workspace) {
  let ret = {
    allIds: [],
    byId: {},
  };
  for (let g of workspace.groups) {
    ret.allIds.push(g.groupId);
    ret.byId[g.groupId] = g;
  }
  return ret;
}

/**
 * Maps the adjustments to a structure with 'allIds' and 'byId' so we can easily find specific
 * adjustments.
 */
export function normalizeAdjustments(workspace) {
  let ret = {
    allIds: [],
    byId: {},
  };
  for (let a of workspace.adjustments) {
    ret.allIds.push(a.adjustmentId);
    ret.byId[a.adjustmentId] = a;
  }
  return ret;
}
